import { isAdaApp } from "../../../utils/white-label";
import { AppLogo } from "../components/app-logo";

export function RecordingPage() {
    return (
        <div className="h-screen bg-white">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-8 offset-md-2">
                        <div
                            className={
                                isAdaApp() ? "text-center" : "text-center m-4"
                            }
                        >
                            <a href="/">
                                <AppLogo />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-8 offset-md-2 p-3 text-center">
                        <h4>Recording...</h4>
                    </div>
                </div>
            </div>
        </div>
    );
}
